/**
 * Hero Slider JavaScript - Fixed for Mobile & Resize
 */

(function() {
  'use strict';

  class HeroSlider {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-slider-track]');
      this.dotsContainer = section.querySelector('[data-slider-dots]');
      this.slides = section.querySelectorAll('[data-slide-index]');
      
      // Temel kontroller
      if (!this.track || this.slides.length <= 0) return;

      this.currentIndex = 0;
      this.autoSlideDuration = parseInt(section.dataset.autoSlide) || 5000;
      this.autoSlideTimer = null;
      
      // Drag değişkenleri
      this.isDragging = false;
      this.startPos = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.animationID = null;
      this.sliderWidth = 0; // Genişlik önbelleği

      // Dots (Init öncesi tanımla)
      this.dots = this.dotsContainer ? this.dotsContainer.querySelectorAll('[data-dot-index]') : [];

      // Resize observer (Performans için debounce eklenebilir ama basit tutuyoruz)
      this.resizeHandler = this.handleResize.bind(this);

      this.init();
    }

    init() {
      this.updateDimensions(); // Genişliği hesapla
      this.setupDots();
      this.setupAutoSlide();
      this.setupDrag();
      this.setupKeyboard();
      this.updateDots(); // İlk açılışta dot durumunu ayarla
      
      // Resize olayını dinle (Mobilde dönüşlerde çok önemlidir)
      window.addEventListener('resize', this.resizeHandler);
    }

    // Genişlik hesaplamasını tek bir yerde yap
    updateDimensions() {
      this.sliderWidth = this.track.parentElement.clientWidth || this.track.offsetWidth;
      // Slider yeniden boyutlandığında mevcut slide'a odaklan
      this.setPositionByIndex(); 
    }

    handleResize() {
      // Resize sırasında animasyonu durdur ve konumu düzelt
      this.stopAutoSlide();
      this.updateDimensions();
      this.startAutoSlide();
    }

    setupDots() {
      if(!this.dots.length && this.dotsContainer) {
         // Dotlar dinamik oluşturuluyorsa tekrar seçmeyi dene
         this.dots = this.dotsContainer.querySelectorAll('[data-dot-index]');
      }

      this.dots.forEach((dot, index) => {
        // Eski event listenerları temizlemek zor olduğu için cloneNode yapılabilir 
        // ama basitlik adına direkt ekliyoruz.
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToSlide(index);
        });
      });
    }

    setupAutoSlide() {
      if (this.autoSlideDuration > 0 && this.slides.length > 1) {
        this.startAutoSlide();
      }
    }

    startAutoSlide() {
      this.stopAutoSlide();
      this.autoSlideTimer = setInterval(() => {
        this.nextSlide();
      }, this.autoSlideDuration);
    }

    stopAutoSlide() {
      if (this.autoSlideTimer) {
        clearInterval(this.autoSlideTimer);
        this.autoSlideTimer = null;
      }
    }

    setupDrag() {
      const wrapper = this.section.querySelector('.hero-slider__wrapper') || this.section;
      
      // Touch events
      wrapper.addEventListener('touchstart', this.touchStart.bind(this), { passive: true });
      wrapper.addEventListener('touchmove', this.touchMove.bind(this), { passive: false });
      wrapper.addEventListener('touchend', this.touchEnd.bind(this));
      
      // Mouse events
      wrapper.addEventListener('mousedown', this.touchStart.bind(this));
      wrapper.addEventListener('mousemove', this.touchMove.bind(this));
      wrapper.addEventListener('mouseup', this.touchEnd.bind(this));
      wrapper.addEventListener('mouseleave', () => {
        if(this.isDragging) this.touchEnd();
      });
    }

    getPositionX(event) {
      return event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
    }

    touchStart(event) {
      this.isDragging = true;
      this.startPos = this.getPositionX(event);
      this.stopAutoSlide(); // Sürüklerken otomatiği durdur
      
      // Animasyon frame'ini başlat
      this.animationID = requestAnimationFrame(this.animation.bind(this));
      
      // CSS class ekle (cursor grabbing vs için)
      this.track.classList.add('is-dragging');
    }

    touchMove(event) {
      if (!this.isDragging) return;
      
      const currentPosition = this.getPositionX(event);
      const diff = currentPosition - this.startPos;
      
      // Mobilde dikey scroll'u engellememek için kontrol
      // Eğer yatay hareket dikeyden fazlaysa preventDefault yap
      // Basit çözüm: Sadece yatay slider olduğu için direkt hesaplıyoruz
      this.currentTranslate = this.prevTranslate + diff;
    }

    touchEnd() {
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
      cancelAnimationFrame(this.animationID);

      const movedBy = this.currentTranslate - this.prevTranslate;
      const threshold = 50; // Hassasiyet

      // Slide değişimi kararı
      if (movedBy < -threshold && this.currentIndex < this.slides.length - 1) {
        this.currentIndex += 1;
      } else if (movedBy > threshold && this.currentIndex > 0) {
        this.currentIndex -= 1;
      }

      this.setPositionByIndex();
      this.startAutoSlide();
    }

    animation() {
      if (this.isDragging) {
        this.setSliderPosition();
        requestAnimationFrame(this.animation.bind(this));
      }
    }

    setSliderPosition() {
      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    setPositionByIndex() {
      // O anki genişliğe göre tam konumu hesapla
      this.currentTranslate = this.currentIndex * -this.sliderWidth;
      this.prevTranslate = this.currentTranslate;
      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
      this.updateDots();
    }

    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.currentIndex = index;
      this.setPositionByIndex();
      this.startAutoSlide();
    }

    nextSlide() {
      // Loop (döngü) mantığı: Sonuncudaysa başa dön
      if (this.currentIndex >= this.slides.length - 1) {
        this.goToSlide(0);
      } else {
        this.goToSlide(this.currentIndex + 1);
      }
    }

    prevSlide() {
      if (this.currentIndex <= 0) {
        this.goToSlide(this.slides.length - 1);
      } else {
        this.goToSlide(this.currentIndex - 1);
      }
    }

    updateDots() {
      // Dot container yoksa veya boşsa işlem yapma
      if (!this.dots || this.dots.length === 0) return;
      
      this.dots.forEach((dot, index) => {
        // İndex eşleşmesini güvenli hale getir
        const dotIndex = parseInt(dot.dataset.dotIndex) || index;
        
        if (index === this.currentIndex) {
          dot.classList.add('hero-slider__dot--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('hero-slider__dot--active');
          dot.removeAttribute('aria-current');
        }
      });
    }

    setupKeyboard() {
      this.section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });
    }
  }

  // Başlatma Fonksiyonları
  function initHeroSliders() {
    const heroSliders = document.querySelectorAll('.hero-slider[data-section-id]');
    heroSliders.forEach(section => {
      // Çakışmayı önlemek için eğer zaten tanımlıysa tekrar başlatma
      if (!section.dataset.sliderInitialized) {
        new HeroSlider(section);
        section.dataset.sliderInitialized = "true";
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSliders);
  } else {
    initHeroSliders();
  }

  // Shopify Theme Editor Desteği
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.detail.container.querySelector('.hero-slider[data-section-id]');
      if (section) {
        new HeroSlider(section);
        section.dataset.sliderInitialized = "true";
      }
    });
  }
})();